module.exports = __webpack_public_path__ + "img/Valores.a5e7b4e1.jpg";